import type { FacetClickSource } from '../Filter.types';

/**
 * The `data-*` attributes every filter checkbox carries. `useFilterChangeHandler` reads them
 * off the changed input, so the control surfaces (rail, drawer) don't each need their own
 * handler to report which option, surface and facet a click came from.
 */
export const getCheckboxInputProps = (compositeCode: string, source: FacetClickSource, facetGroupCode: string) => ({
  ['data-item-id']: compositeCode,
  ['data-source']: source,
  ['data-facet']: facetGroupCode,
});
